// extracted by mini-css-extract-plugin
export var currencyInput = "_o2-1";
export var currencySymbol = "_o2-0";